export const _CHANGE_LAYOUT_MODE = '_CHANGE_LAYOUT_MODE';


export const _CHANGE_LAYOUT_LOADER = '_CHANGE_LAYOUT_LOADER';
